module.exports = __webpack_public_path__ + "img/titannical-steaming.f66a0134.jpg";